import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-disclaimer-main",
	templateUrl: "./disclaimer-main.component.html",
	styleUrls: ["./disclaimer-main.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass, TranslateModule],
})
export class DisclaimerMainComponent {
	readonly hideALittle = input(false);

	readonly isChatbot = input(false);

	readonly message = input<string>("no message provided");
}
